import { render, staticRenderFns } from "./CreateNote.vue?vue&type=template&id=534f68c8&scoped=true&"
import script from "./CreateNote.vue?vue&type=script&lang=ts&"
export * from "./CreateNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f68c8",
  null
  
)

export default component.exports